import React, { useEffect } from 'react';

const ReportingTags = () => {
  React.useEffect(() => {
    // eslint-disable-next-line no-console
    console.warn('Placeholder: ReportingTags is not implemented yet.');
  }, []);
  return (
    <>
  { /*ReportingTags */} 
 </>
  );
};

export default ReportingTags;
